import { IRootState } from '../reducer'
import { prefix } from './actions'

export const boxViewLink = (state: IRootState) => state[prefix].viewer.link

export const isBoxViewerOpen = (state: IRootState) => !!state[prefix].viewer.link

export const boxViewerFailureMessage = (state: IRootState) => state[prefix].viewer.failureMessage

export const boxViewerMode = (state: IRootState) => state[prefix].boxViewerMode

export const boxViewerFileId = (state: IRootState) => state[prefix].boxViewerFileId

export const isBoxViewerExpanded = (state: IRootState) => state[prefix].isBoxViewerExpanded
